import axios from "../axios";

class TenderTypeService {
    getListAll() {
        return axios.get("tender-type?perPage=1000");
    }
}

export default new TenderTypeService();
